import React from "react";
import classes from "./EventRow.scss";
import classNames from "classnames";
import { useI18n } from "Hooks";

const EventRow = ({
  label,
  icon,
  renderComponent,
  className = "",
  labelClass = "",
  isRequired = false,
}) => {
  const { t } = useI18n(["calendar", "common", "schoolSetup"]);
  return (
    <div className={classNames(classes.eventRowContainer, className)}>
      <div className={classNames(classes.eventRowHeader, labelClass)}>
        {icon}
        <span className={classNames(classes.eventRowHeaderText, "text-label")}>
          {t(`${label}`)}
        </span>
        {isRequired ? (
          <div className={classNames(classes.required, "text-label")}>*</div>
        ) : null}
      </div>
      {renderComponent && renderComponent()}
    </div>
  );
};

export default EventRow;
